/**
 * Preset starter recipes database.
 */

export const PRESET_RECIPES = [
  {
    id: 'hazy_neipa',
    name: 'Juicy Hazy NEIPA (Tropical Hop Bomb)',
    styleId: '21C',
    description: 'Saftig, fyllig och kraftfullt aromhumlad Hazy IPA med Citra, Mosaic, Simcoe och havremalt.',
    recipe: {
      name: 'Juicy Hazy NEIPA',
      styleId: '21C',
      batchVolume: 20,
      boilVolume: 25,
      boilTime: 60,
      efficiency: 75,
      notes: 'Ladda med whirlpool- och torrhumle. Använd Lallemand Verdant, Wyeast 1318 eller Voss Kveik.',
    },
    fermentables: [
      { name: 'Viking Pale Ale Malt', amount: 3.8, ebc: 6, yield: 79, type: 'base' },
      { name: 'Vetemalt (Ljus)', amount: 0.8, ebc: 4, yield: 79, type: 'base' },
      { name: 'Havremalt / Oat Malt', amount: 0.6, ebc: 5, yield: 72, type: 'base' },
      { name: 'Havreflingor (Flaked Oats)', amount: 0.4, ebc: 3, yield: 65, type: 'adjunct' },
    ],
    hops: [
      { name: 'Magnum', amount: 12, alpha: 12.0, time: 60, form: 'pellets', use: 'kok' },
      { name: 'Citra', amount: 30, alpha: 12.0, time: 20, form: 'pellets', use: 'whirlpool', whirlpoolTemp: 80 },
      { name: 'Mosaic', amount: 30, alpha: 12.5, time: 20, form: 'pellets', use: 'whirlpool', whirlpoolTemp: 80 },
      { name: 'Citra', amount: 50, alpha: 12.0, time: 0, form: 'pellets', use: 'torrhumle' },
      { name: 'Mosaic', amount: 50, alpha: 12.5, time: 0, form: 'pellets', use: 'torrhumle' },
    ],
    yeast: {
      name: 'Lallemand Verdant IPA',
      lab: 'Lallemand',
      type: 'ale',
      attMin: 75,
      attMax: 82,
      tempMin: 19,
      tempMax: 23,
      notes: 'Ger silkeslen munkänsla och tropiska estrar.',
    },
    mash: [
      { name: 'Sackarifikation', type: 'Infusion', temp: 67, time: 60 },
      { name: 'Avmäskning', type: 'Steg', temp: 78, time: 10 },
    ],
    water: {
      volume: 25,
      base: { ca: 17, mg: 3, na: 14, cl: 120, so4: 60, hco3: 65 },
      salts: { gypsum: 1, calciumChloride: 4, epsomSalt: 0, tableSalt: 1, chalk: 0, bakingSoda: 0 },
    },
  },
  {
    id: 'west_coast_ipa',
    name: 'West Coast IPA (Krispig & Tallbarrs-Citrus)',
    styleId: '21A',
    description: 'Klassisk krispig och ren West Coast IPA med spetsig beska, kåda, grapefrukt och tall.',
    recipe: {
      name: 'West Coast IPA',
      styleId: '21A',
      batchVolume: 20,
      boilVolume: 25,
      boilTime: 60,
      efficiency: 75,
      notes: 'Krispig profil. Bryggs på Pale Ale malt, Simcoe, Citra och Centennial.',
    },
    fermentables: [
      { name: 'Viking Pale Ale Malt', amount: 5.0, ebc: 6, yield: 79, type: 'base' },
      { name: 'Weyermann Wienermalt / Vienna', amount: 0.5, ebc: 8, yield: 78, type: 'base' },
      { name: 'Caramalt / Crystal 20', amount: 0.3, ebc: 40, yield: 74, type: 'cara' },
    ],
    hops: [
      { name: 'Columbus / CTZ', amount: 20, alpha: 15.0, time: 60, form: 'pellets', use: 'kok' },
      { name: 'Centennial', amount: 25, alpha: 10.0, time: 15, form: 'pellets', use: 'kok' },
      { name: 'Simcoe', amount: 30, alpha: 13.0, time: 5, form: 'pellets', use: 'kok' },
      { name: 'Citra', amount: 40, alpha: 12.0, time: 0, form: 'pellets', use: 'torrhumle' },
      { name: 'Simcoe', amount: 40, alpha: 13.0, time: 0, form: 'pellets', use: 'torrhumle' },
    ],
    yeast: {
      name: 'SafAle US-05',
      lab: 'Fermentis',
      type: 'ale',
      attMin: 78,
      attMax: 82,
      tempMin: 18,
      tempMax: 21,
      notes: 'Jäs svalt för ren profil utan estrar.',
    },
    mash: [
      { name: 'Sackarifikation', type: 'Infusion', temp: 65, time: 60 },
      { name: 'Avmäskning', type: 'Steg', temp: 78, time: 10 },
    ],
    water: {
      volume: 25,
      base: { ca: 50, mg: 10, na: 20, cl: 50, so4: 150, hco3: 50 },
      salts: { gypsum: 5, calciumChloride: 1, epsomSalt: 1, tableSalt: 0, chalk: 0, bakingSoda: 0 },
    },
  },
  {
    id: 'klassisk_pilsner',
    name: 'Klassisk Lager / Pilsner (Krispig & Mjuk)',
    styleId: '5D',
    description: 'Ren, krispig och balanserad hantverkspilsner med 100% Pilsnermalt, Saaz och mjuk beska.',
    recipe: {
      name: 'Klassisk Lager / Pilsner',
      styleId: '5D',
      batchVolume: 20,
      boilVolume: 25,
      boilTime: 60,
      efficiency: 75,
      notes: 'Klassisk pilsner med Saflager W-34/70 eller Novalager.',
    },
    fermentables: [
      { name: 'Weyermann Pilsner Malt', amount: 3.9, ebc: 3.5, yield: 80, type: 'base' },
      { name: 'CaraPils / Carafoam (Weyermann)', amount: 0.2, ebc: 4, yield: 73, type: 'cara' },
    ],
    hops: [
      { name: 'Perle', amount: 20, alpha: 7.0, time: 60, form: 'pellets', use: 'kok' },
      { name: 'Saaz', amount: 30, alpha: 3.5, time: 15, form: 'pellets', use: 'kok' },
      { name: 'Saaz', amount: 20, alpha: 3.5, time: 5, form: 'pellets', use: 'kok' },
    ],
    yeast: {
      name: 'SafLager W-34/70',
      lab: 'Fermentis',
      type: 'lager',
      attMin: 80,
      attMax: 84,
      tempMin: 9,
      tempMax: 13,
      notes: 'Jäs svalt vid 10–12°C. Kan även jäsa med Novalager vid 15°C.',
    },
    mash: [
      { name: 'Sackarifikation', type: 'Infusion', temp: 66, time: 60 },
      { name: 'Avmäskning', type: 'Steg', temp: 78, time: 10 },
    ],
    water: {
      volume: 25,
      base: { ca: 17, mg: 3, na: 14, cl: 20, so4: 20, hco3: 65 },
      salts: { gypsum: 1, calciumChloride: 1, epsomSalt: 0, tableSalt: 0, chalk: 0, bakingSoda: 0 },
    },
  },
  {
    id: 'choklad_porter',
    name: 'Fyllig Choklad & Kaffe Porter',
    styleId: '13C',
    description: 'Mörk, fyllig porter med rika toner av mörk choklad, kaffe och knäckig karamellsötma.',
    recipe: {
      name: 'Fyllig Choklad & Kaffe Porter',
      styleId: '13C',
      batchVolume: 20,
      boilVolume: 25,
      boilTime: 60,
      efficiency: 75,
      notes: 'Fyllig portersmak med Carafa Special, Brown malt och mjuk chokladmalt.',
    },
    fermentables: [
      { name: 'Crisp Maris Otter', amount: 3.4, ebc: 6, yield: 78, type: 'base' },
      { name: 'Caramünchen I (Weyermann)', amount: 0.4, ebc: 50, yield: 70, type: 'cara' },
      { name: 'Brown Malt', amount: 0.3, ebc: 150, yield: 70, type: 'roasted' },
      { name: 'Viking Chocolate Light', amount: 0.25, ebc: 450, yield: 65, type: 'roasted' },
      { name: 'Carafa Special I (Avhästad)', amount: 0.15, ebc: 600, yield: 67, type: 'roasted' },
    ],
    hops: [
      { name: 'East Kent Goldings', amount: 35, alpha: 5.0, time: 60, form: 'pellets', use: 'kok' },
      { name: 'Fuggles', amount: 20, alpha: 4.5, time: 15, form: 'pellets', use: 'kok' },
    ],
    yeast: {
      name: 'SafAle S-04',
      lab: 'Fermentis',
      type: 'ale',
      attMin: 71,
      attMax: 75,
      tempMin: 18,
      tempMax: 21,
      notes: 'Ger mjuk fyllighet och låter maltkaraktären skinna.',
    },
    mash: [
      { name: 'Sackarifikation', type: 'Infusion', temp: 67, time: 60 },
      { name: 'Avmäskning', type: 'Steg', temp: 78, time: 10 },
    ],
    water: {
      volume: 25,
      base: { ca: 32, mg: 7, na: 18, cl: 30, so4: 30, hco3: 120 },
      salts: { gypsum: 1, calciumChloride: 2, epsomSalt: 0, tableSalt: 0, chalk: 1, bakingSoda: 1 },
    },
  },
  {
    id: 'hefeweizen',
    name: 'Bayersk Hefeweizen (Banan & Kryddnejlika)',
    styleId: '10A',
    description: 'Klassiskt tyskt veteöl med aromer av banan, kryddnejlika och en disig silkeslen kropp.',
    recipe: {
      name: 'Bayersk Hefeweizen',
      styleId: '10A',
      batchVolume: 20,
      boilVolume: 25,
      boilTime: 60,
      efficiency: 75,
      notes: 'Fruktigt veteöl med skumkrona.',
    },
    fermentables: [
      { name: 'Vetemalt (Ljus)', amount: 2.4, ebc: 4, yield: 79, type: 'base' },
      { name: 'Weyermann Pilsner Malt', amount: 1.7, ebc: 3.5, yield: 80, type: 'base' },
      { name: 'Weyermann Münchenmalt I', amount: 0.3, ebc: 15, yield: 77, type: 'base' },
    ],
    hops: [
      { name: 'Hallertau Mittelfrüh', amount: 25, alpha: 4.0, time: 60, form: 'pellets', use: 'kok' },
    ],
    yeast: {
      name: 'Wyeast 3068 Weizen',
      lab: 'Wyeast',
      type: 'wheat',
      attMin: 73,
      attMax: 77,
      tempMin: 18,
      tempMax: 22,
      notes: 'Jäs runt 20°C för bra balans mellan banan och kryddnejlika.',
    },
    mash: [
      { name: 'Proteinrast', type: 'Steg', temp: 52, time: 15 },
      { name: 'Sackarifikation', type: 'Steg', temp: 67, time: 45 },
      { name: 'Avmäskning', type: 'Steg', temp: 78, time: 10 },
    ],
    water: {
      volume: 25,
      base: { ca: 40, mg: 8, na: 15, cl: 40, so4: 40, hco3: 80 },
      salts: { gypsum: 1, calciumChloride: 1, epsomSalt: 0, tableSalt: 0, chalk: 0, bakingSoda: 0 },
    },
  },
  {
    id: 'sommar_session_ale',
    name: 'Sommar Session Pale Ale (4.8% Lättdrucken)',
    styleId: '18B',
    description: 'Uppfriskande och lättdrucken 4.8% sommar-ale laddad med fräsch Cascade- & Citra-humle.',
    recipe: {
      name: 'Sommar Session Pale Ale',
      styleId: '18B',
      batchVolume: 20,
      boilVolume: 25,
      boilTime: 60,
      efficiency: 75,
      notes: 'Perfekt 4.8% session ale med krispig kropp och citrusaktig humlearom.',
    },
    fermentables: [
      { name: 'Viking Pale Ale Malt', amount: 3.75, ebc: 6, yield: 79, type: 'base' },
      { name: 'Viking Cookie Malt', amount: 0.2, ebc: 50, yield: 73, type: 'cara' },
      { name: 'CaraPils / Carafoam (Weyermann)', amount: 0.15, ebc: 4, yield: 73, type: 'cara' },
    ],
    hops: [
      { name: 'Magnum', amount: 12, alpha: 12.0, time: 60, form: 'pellets', use: 'kok' },
      { name: 'Cascade', amount: 20, alpha: 5.5, time: 15, form: 'pellets', use: 'kok' },
      { name: 'Citra', amount: 25, alpha: 12.0, time: 5, form: 'pellets', use: 'kok' },
    ],
    yeast: {
      name: 'Lallemand BRY-97 West Coast',
      lab: 'Lallemand',
      type: 'ale',
      attMin: 75,
      attMax: 80,
      tempMin: 17,
      tempMax: 20,
      notes: 'Ren och krispig avslutning med lite mer kropp än US-05 – passar en lätt session ale.',
    },
    mash: [
      { name: 'Sackarifikation', type: 'Infusion', temp: 66, time: 60 },
      { name: 'Avmäskning', type: 'Steg', temp: 78, time: 10 },
    ],
    water: {
      volume: 25,
      base: { ca: 17, mg: 3, na: 14, cl: 20, so4: 50, hco3: 65 },
      salts: { gypsum: 2, calciumChloride: 1, epsomSalt: 0, tableSalt: 0, chalk: 0, bakingSoda: 0 },
    },
  },
  {
    id: 'gotlandsdricka',
    name: 'Gotlandsdricka / Svensk Gårdsöl',
    styleId: '25B',
    description: 'Traditionell nordisk brygd med bokrökt malt, svedjeråg och snabb Kveik-jäsning.',
    recipe: {
      name: 'Gotlandsdricka / Svensk Gårdsöl',
      styleId: '25B',
      batchVolume: 20,
      boilVolume: 25,
      boilTime: 60,
      efficiency: 75,
      notes: 'Traditionell brygd. Tillsätt gärna färskt enbärsris i mäsken.',
    },
    fermentables: [
      { name: 'Viking Smoked Malt (Rökmalt)', amount: 2.2, ebc: 6, yield: 77, type: 'base' },
      { name: 'Viking Pilsner Malt', amount: 1.8, ebc: 4, yield: 80, type: 'base' },
      { name: 'Warbro Kvarn Svedjeråg', amount: 0.5, ebc: 7, yield: 72, type: 'base' },
      { name: 'Caramünchen I (Weyermann)', amount: 0.15, ebc: 50, yield: 70, type: 'cara' },
      { name: 'Honung', amount: 0.25, ebc: 3, yield: 75, type: 'sugar' },
    ],
    hops: [
      { name: 'Svensk Korsta (SWE 25)', amount: 25, alpha: 8.0, time: 60, form: 'pellets', use: 'kok' },
      { name: 'Saaz', amount: 20, alpha: 3.5, time: 15, form: 'pellets', use: 'kok' },
    ],
    yeast: {
      name: 'Lallemand Voss Kveik',
      lab: 'Lallemand',
      type: 'ale',
      attMin: 75,
      attMax: 82,
      tempMin: 28,
      tempMax: 38,
      notes: 'Jäs varmt i rumstemperatur (28–35°C) för snabb och fruktig avslutning.',
    },
    mash: [
      { name: 'Råg & Rök-rast', type: 'Steg', temp: 64, time: 45 },
      { name: 'Sackarifikation', type: 'Steg', temp: 70, time: 20 },
      { name: 'Avmäskning', type: 'Steg', temp: 78, time: 10 },
    ],
    water: {
      volume: 25,
      base: { ca: 90, mg: 15, na: 35, cl: 60, so4: 50, hco3: 280 },
      salts: { gypsum: 1, calciumChloride: 1, epsomSalt: 0, tableSalt: 0, chalk: 0, bakingSoda: 0 },
    },
  },
];
